import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { sify } from 'chinese-conv'
import _ from 'lodash'
import ClearIcon from '@mui/icons-material/Clear'
import AddIcon from '@mui/icons-material/Add'
import DeleteIcon from '@mui/icons-material/Delete'
import CachedIcon from '@mui/icons-material/Cached'
import LowPriorityIcon from '@mui/icons-material/LowPriority'
import AllInclusiveIcon from '@mui/icons-material/AllInclusive'
import CancelIcon from '@mui/icons-material/Cancel'
import { Drawer, Box, Stack, Typography, Tooltip, IconButton } from '@mui/material'
import { constants as cons, IMAGE_TYPE, PICTURE_SIZE, UPLOAD_TYPE } from '../../Constants/constants'
import { setQueueTemplate, setQueueTemplateTimeSectionValue, setQueueTemplateTableTypeValue } from '../../actions/queueTemplateAction'
import { EditCreateDisplay } from '../../Component/EditCreateDisplay/EditCreateDisplay'
import { TempTextInput } from '../../Component/Input/TempTextInput'
import { TempAutoSelectInput } from '../../Component/Input/TempAutoSelectInput'
import { TempBtn } from '../../Component/Input/TempBtn'
import { TempCheckBox } from '../../Component/Input/TempCheckBox'
import { TempCustomCheckBox } from '../../Component/Custom/TempCustomCheckBox'
import { TicketTypeList } from '../TicketType/TicketTypeList'
import { TicketTypeCreate } from '../TicketType/TicketTypeCreate'
import QueueTemplateValidation from '../../validations/queueTemplateValidation'
import { queueTemplateValidationConstants as validationCo } from '../../Constants/validationConstants'
import { getIsSyncSessionDateWithAllTableTypes, getIsSyncRequestTicketTimeFieldsWithAllTableTypes, getIsSyncTimeFieldsWithAllTableTypes } from './queueTemplateUtil'
import '../../styles/colorPicker.scss'
import { QueueTemplateColorPicker } from './QueueTemplateColorPicker'
import { Clear } from '@mui/icons-material'
import { getTableTypeBackgroundColor, getTableTypeForegroundColor } from '../../helper/util'
import { SoundInfoVoiceDropdown } from '../MerchantConfig/SoundInfoVoiceDropdown'
import { DefaultColorSetDropDown } from './DefaultColorSetDropDown'
import MUIAccordion from '../../Component/common/collapse/MUIAccordion'
import { BOOLEAN_OPTIONS } from '../../Constants/type'
import { UploadImageV2 } from '../../Component/UploadImage/UploadImageV2'
import moment from 'moment'

const AUTO_TASK_DEFAULT_ITEM = {
  id: null,
  taskType: null,
  mobile: true,
  kiosk: true,
  executionType: 'EXACT_DATE_TIME',
  executionExactDateTime: null,
  executionResetTime: null,
  executionOffsetMinute: null,
  status: 'A',
}

const TASK_TYPE_OPTIONS = [
  { value: 'REQUEST_TICKET_PENDING', name: 'REQUEST_TICKET_PENDING' },
  { value: 'REQUEST_TICKET_ACTIVE', name: 'REQUEST_TICKET_ACTIVE' },
]

const EXECUTION_TYPE_OPTIONS = [
  { value: 'EXACT_DATE_TIME', name: 'EXACT_DATE_TIME' },
  { value: 'RESET_OFFSET_MINUTE', name: 'RESET_OFFSET_MINUTE' },
  { value: 'RESET_TIME', name: 'RESET_TIME' },
]

export const QueueTemplateTableType = ({ setCustomIdNumber, customIdNumber, soundVoiceList }) => {
  const dispatch = useDispatch()
  const savedQueueTemplate = useSelector((state) => state.queueTemplate.ui.queueTemplate)
  const savedTableType = useSelector((state) => state.queueTemplate.ui.tableType)
  const savedTableTypeColorList = useSelector((state) => state.queueTemplate.ui.tableTypeColorList)
  const savedDefaultTableTypeColorList = useSelector((state) => state.queueTemplate.ui.defaultTableTypeColorList)
  const [tableTypeInputList, setTableTypeInputList] = useState(_.cloneDeep(savedTableType))
  const [reload, setReload] = useState(false)
  const [showTicketTypeTextPanel, setShowTicketTypeTextPanel] = useState(false)
  const [showTicketTypeCreatePanel, setShowTicketTypeCreatePanel] = useState(false)

  // eslint-disable-next-line no-unused-vars
  const [errorVersion, setErrorVersion] = useState(QueueTemplateValidation.getVersion())

  const resource = 'TableType'
  const autoTaskList = Array.isArray(savedTableType.autoTaskList) ? savedTableType.autoTaskList : []
  const contents = [
    {
      tab: (
        <>
          <TempAutoSelectInput
            inputSetting={{
              label: { resource: resource, key: 'type' },
              value: savedTableType.type,
              selectValue: cons.CHOICES.QUEUE_TEMPLATE.TYPE,
              name: 'type',
            }}
            handleChange={onChangeInput}
          />
          {savedTableType.id && (
            <TempAutoSelectInput
              inputSetting={{
                label: { resource: resource, key: 'status' },
                value: savedTableType.status,
                selectValue: cons.CHOICES.QUEUE_TEMPLATE.TICKET_TYPE_STATUS,
                name: 'status',
                disableClearable: true,
                helperTextIcon: true,
                helperText: QueueTemplateValidation.getErrorMessages(validationCo.KEY_TABLE_TYPE_STATUS, savedTableType.customId).map((error) => {
                  return error
                }),
              }}
              handleChange={onChangeInput}
            />
          )}
          <TempAutoSelectInput
            inputSetting={{
              label: { resource: resource, key: 'defaultStatus' },
              value: savedTableType.defaultStatus,
              selectValue: cons.CHOICES.QUEUE_TEMPLATE.DEFAULT_STATUS,
              name: 'defaultStatus',
              disableClearable: true,
              helperTextIcon: true,
              helperText: QueueTemplateValidation.getErrorMessages(validationCo.KEY_TABLE_TYPE_STATUS, savedTableType.customId).map((error) => {
                return error
              }),
            }}
            handleChange={onChangeInput}
          />
          <div></div>
          <TempAutoSelectInput
            inputSetting={{
              label: { resource: resource, key: 'tableType' },
              value: savedTableType.tableType?.tableType,
              selectValue: cons.CHOICES.QUEUE_TEMPLATE.TIME_SECTION_ID,
              name: 'tableType.tableType',
              disableClearable: true,
              helperTextIcon: true,
              helperText: QueueTemplateValidation.getErrorMessages(validationCo.KEY_TABLE_TYPE, savedTableType.customId).map((error) => {
                return error
              }),
              freeSolo: true,
              disableStatusThemeColor: true,
            }}
            handleChange={onChangeInput}
          />
          <TempAutoSelectInput
            inputSetting={{
              label: { resource: resource, key: 'parentTableType' },
              value: savedTableType.tableType?.parentTableType,
              name: 'tableType.parentTableType',
              helperTextIcon: true,
              helperText: QueueTemplateValidation.getErrorMessages(validationCo.KEY_PARENT_TABLE_TYPE, savedTableType.customId).map((error) => {
                return error
              }),
              freeSolo: true,
              disableStatusThemeColor: true,
              selectValue: getCurrentTimeSectionPossibleParentTableType(),
              // endAdornmentIconButton: <Clear fontSize={cons.SIZE.SMALL} />,
              // onClickEndAdornmentIconButton: () => {
              //   onChangeFieldToNull('parentTableType')
              // },
            }}
            handleChange={onChangeInput}
          />
          <MUIAccordion title="SESSION DATE & START/ END TIME">
            <TempTextInput
              inputSetting={{
                label: { resource: resource, key: 'sessionDate' },
                value: savedTableType.sessionDate,
                name: 'sessionDate',
                disabled: getIsSyncSessionDateWithAllTableTypes(savedTableType.timeSectionCustomId, savedQueueTemplate),
                type: cons.TYPE.DATE,
              }}
              handleChange={onChangeInput}
            />
            <div></div>
            <TempTextInput
              inputSetting={{
                label: { resource: resource, key: 'startTime' },
                value: savedTableType.startTime,
                name: 'startTime',
                step: '2',
                helperTextIcon: true,
                helperText: QueueTemplateValidation.getErrorMessages(validationCo.KEY_TABLE_TYPE_START_TIME, savedTableType.customId).map((error) => {
                  return error
                }),
                disabled: getIsSyncTimeFieldsWithAllTableTypes(savedTableType.timeSectionCustomId, savedQueueTemplate),
                type: cons.TYPE.TIME,
              }}
              handleChange={onChangeInput}
            />
            <TempTextInput
              inputSetting={{
                label: { resource: resource, key: 'endTime' },
                value: savedTableType.endTime,
                name: 'endTime',
                step: '2',
                helperTextIcon: true,
                helperText: QueueTemplateValidation.getErrorMessages(validationCo.KEY_TABLE_TYPE_END_TIME, savedTableType.customId).map((error) => {
                  return error
                }),
                disabled: getIsSyncTimeFieldsWithAllTableTypes(savedTableType.timeSectionCustomId, savedQueueTemplate),
                type: cons.TYPE.TIME,
              }}
              handleChange={onChangeInput}
            />
            <TempTextInput
              inputSetting={{
                label: { resource: resource, key: 'timeSectionDescription' },
                value: savedTableType.timeSectionDescription,
                name: 'timeSectionDescription',
                onClickEndAdornmentIconButton: () => generateTimeSectionDescription(),
                endAdornmentIconButton: <CachedIcon />,
                disabledEndAdornmentIconButton: !!(
                  !savedTableType.startTime ||
                  !savedTableType.endTime ||
                  getIsSyncTimeFieldsWithAllTableTypes(savedTableType.timeSectionCustomId, savedQueueTemplate)
                ),
                disabledOnClickInputField: true,
                disabledStyle: true,
                multiline: true,
                disabled: getIsSyncTimeFieldsWithAllTableTypes(savedTableType.timeSectionCustomId, savedQueueTemplate),
              }}
              handleChange={onChangeInput}
            />
            <TempTextInput
              inputSetting={{
                label: { resource: resource, key: 'cutOffTime' },
                value: savedTableType.cutOffTime,
                name: 'cutOffTime',
                step: '2',
                type: cons.TYPE.TIME,
                endAdornmentIconButton: <Clear fontSize={cons.SIZE.SMALL} />,
                onClickEndAdornmentIconButton: () => {
                  onChangeFieldToNull('cutOffTime')
                },
              }}
              handleChange={onChangeInput}
            />
            {/* <TempTextInput
              inputSetting={{
                label: { resource: resource, key: 'cutOffMinute' },
                value: savedTableType.cutOffMinute,
                name: 'cutOffMinute',
                helperTextIcon: true,
                helperText: QueueTemplateValidation.getErrorMessages(validationCo.KEY_CUT_OFF_MIN, savedTableType.customId).map((error) => {
                  return error
                }),
                type: cons.TYPE.NUMBER,
                disabled: true,
                disabledOnClickInputField: true,
              }}
              handleChange={onChangeInput}
            /> */}
          </MUIAccordion>
          <MUIAccordion title="DISPLAY CONFIGS">
            <TempAutoSelectInput
              inputSetting={{
                label: { resource: resource, key: 'mobileDisplay' },
                value: savedTableType.mobileDisplay,
                selectValue: cons.CHOICES.QUEUE_TEMPLATE.MOBILE_DISPLAY,
                name: 'mobileDisplay',
                disableClearable: true,
                helperTextIcon: true,
                helperText: QueueTemplateValidation.getErrorMessages(validationCo.KEY_MOBILE_DISPLAY, savedTableType.customId).map((error) => {
                  return error
                }),
              }}
              handleChange={onChangeInput}
            />
            <TempAutoSelectInput
              inputSetting={{
                label: { resource: resource, key: 'mobileTagDisplay' },
                value: savedTableType.mobileTagDisplay,
                selectValue: cons.CHOICES.QUEUE_TEMPLATE.MOBILE_TAG_DISPLAY,
                name: 'mobileTagDisplay',
                disableClearable: true,
              }}
              handleChange={onChangeInput}
            />
            <TempAutoSelectInput
              inputSetting={{
                label: { resource: resource, key: 'mobileReadOnly' },
                value: savedTableType.mobileReadOnly,
                selectValue: cons.CHOICES.QUEUE_TEMPLATE.MOBILE_READ_ONLY,
                name: 'mobileReadOnly',
                disableClearable: true,
                helperTextIcon: true,
                helperText: QueueTemplateValidation.getErrorMessages(validationCo.KEY_MOBILE_READ_ONLY, savedTableType.customId).map((error) => {
                  return error
                }),
              }}
              handleChange={onChangeInput}
            />
            <TempAutoSelectInput
              inputSetting={{
                label: { resource: resource, key: 'kioskDisplay' },
                value: savedTableType.kioskDisplay,
                selectValue: cons.CHOICES.QUEUE_TEMPLATE.KIOSK_DISPLAY,
                name: 'kioskDisplay',
                disableClearable: true,
                helperTextIcon: true,
                helperText: QueueTemplateValidation.getErrorMessages(validationCo.KEY_KIOS_DISPLAY, savedTableType.customId).map((error) => {
                  return error
                }),
              }}
              handleChange={onChangeInput}
            />
            <TempAutoSelectInput
              inputSetting={{
                label: { resource: resource, key: 'kioskTagDisplay' },
                value: savedTableType.kioskTagDisplay,
                selectValue: cons.CHOICES.QUEUE_TEMPLATE.KIOSK_TAG_DISPLAY,
                name: 'kioskTagDisplay',
                disableClearable: true,
              }}
              handleChange={onChangeInput}
            />
            <TempAutoSelectInput
              inputSetting={{
                label: { resource: resource, key: 'kioskReadOnly' },
                value: savedTableType.kioskReadOnly,
                selectValue: cons.CHOICES.QUEUE_TEMPLATE.KIOSK_READ_ONLY,
                name: 'kioskReadOnly',
                disableClearable: true,
                helperTextIcon: true,
                helperText: QueueTemplateValidation.getErrorMessages(validationCo.KEY_KIOS_READ_ONLY, savedTableType.customId).map((error) => {
                  return error
                }),
              }}
              handleChange={onChangeInput}
            />
          </MUIAccordion>
          <MUIAccordion title="DISPLAY LABELS">
            <TempCustomCheckBox
              className="customize-btn"
              value={savedTableType.disableTableTypeKioskLabel}
              customName={{ resource: resource, key: 'isAutoTranslateTableTypeScLabel' }}
              onSelectCheckbox={onSelectCheckbox}
            />
            <TempTextInput
              inputSetting={{
                label: { resource: resource, key: 'tableTypeEnLabel' },
                value: savedTableType.tableType?.kioskLabel?.en,
                name: 'tableType.kioskLabel.en',
                multiline: true,
              }}
              handleChange={onChangeInput}
            />
            <TempTextInput
              inputSetting={{
                label: { resource: resource, key: 'tableTypeTcLabel' },
                value: savedTableType?.tableType?.kioskLabel?.['zh-HK'],
                name: 'tableType.kioskLabel.zh-HK',
                translateName: savedTableType.disableTableTypeKioskLabel ? ['tableType.kioskLabel.zh-CN'] : null,
                inputList: tableTypeInputList,
                setInputList: setTableTypeInputList,
                multiline: true,
              }}
              handleChange={onChangeInput}
            />
            <TempTextInput
              inputSetting={{
                label: { resource: resource, key: 'tableTypeScLabel' },
                value: savedTableType?.tableType?.kioskLabel?.['zh-CN'],
                name: 'tableType.kioskLabel.zh-CN',
                inputList: tableTypeInputList,
                setInputList: setTableTypeInputList,
                disabled: savedTableType.disableTableTypeKioskLabel,
                multiline: true,
              }}
              handleChange={onChangeInput}
            />
            <TempCustomCheckBox
              className="customize-btn"
              value={savedTableType.disableTableTypeMobileLabel}
              customName={{ resource: resource, key: 'isAutoTranslateTableTypeMobileScLabel' }}
              onSelectCheckbox={onSelectCheckbox}
            />
            <TempTextInput
              inputSetting={{
                label: { resource: resource, key: 'tableTypeMobileEnLabel' },
                value: savedTableType?.tableType?.mobileLabel?.en,
                name: 'tableType.mobileLabel.en',
                multiline: true,
              }}
              handleChange={onChangeInput}
            />
            <TempTextInput
              inputSetting={{
                label: { resource: resource, key: 'tableTypeMobileTcLabel' },
                value: savedTableType?.tableType?.mobileLabel?.['zh-HK'],
                name: 'tableType.mobileLabel.zh-HK',
                translateName: savedTableType.disableTableTypeMobileLabel ? ['tableType.mobileLabel.zh-CN'] : null,
                multiline: true,
              }}
              handleChange={onChangeInput}
            />
            <TempTextInput
              inputSetting={{
                label: { resource: resource, key: 'tableTypeMobileScLabel' },
                value: savedTableType?.tableType?.mobileLabel?.['zh-CN'],
                name: 'tableType.mobileLabel.zh-CN',
                disabled: savedTableType.disableTableTypeMobileLabel,
                multiline: true,
              }}
              handleChange={onChangeInput}
            />
            <TempCustomCheckBox
              className="customize-btn"
              value={savedTableType.disableTableTypeTicketLabel}
              customName={{ resource: resource, key: 'isAutoTranslateTableTypeTicketScLabel' }}
              onSelectCheckbox={onSelectCheckbox}
            />
            <TempTextInput
              inputSetting={{
                label: { resource: resource, key: 'tableTypeTicketEnLabel' },
                value: savedTableType?.tableType?.ticketLabel?.en,
                name: 'tableType.ticketLabel.en',
                multiline: true,
                placeholder: savedTableType?.tableType?.ticketLabel?.en === null ? 'Not defined' : '',
                endAdornmentIconButton: <Clear fontSize={cons.SIZE.SMALL} />,
                onClickEndAdornmentIconButton: () => {
                  onChangeFieldToNull('tableType.ticketLabel.en')
                },
              }}
              handleChange={onChangeInput}
            />
            <TempTextInput
              inputSetting={{
                label: { resource: resource, key: 'tableTypeTicketTcLabel' },
                value: savedTableType.tableType?.ticketLabel?.['zh-HK'],
                name: 'tableType.ticketLabel.zh-HK',
                multiline: true,
                placeholder: savedTableType.tableType?.ticketLabel?.['zh-HK'] === null ? 'Not defined' : '',
                endAdornmentIconButton: <Clear fontSize={cons.SIZE.SMALL} />,
                translateName: savedTableType.disableTableTypeTicketLabel ? ['tableType.ticketLabel.zh-CN'] : null,
                onClickEndAdornmentIconButton: () => {
                  onChangeFieldToNull('tableType.ticketLabel.zh-HK')
                },
              }}
              handleChange={onChangeInput}
            />
            <TempTextInput
              inputSetting={{
                label: { resource: resource, key: 'tableTypeTicketScLabel' },
                value: savedTableType?.tableType?.ticketLabel?.['zh-CN'],
                name: 'tableType.ticketLabel.zh-CN',
                multiline: true,
                disabled: savedTableType.disableTableTypeTicketLabel,
                disabledEndAdornmentIconButton: savedTableType.disableTableTypeTicketLabel,
                placeholder: savedTableType?.tableType?.ticketLabel?.['zh-CN'] === null ? 'Not defined' : '',
                endAdornmentIconButton: <Clear fontSize={cons.SIZE.SMALL} />,
                onClickEndAdornmentIconButton: savedTableType.disableTableTypeTicketLabel
                  ? null
                  : () => {
                      onChangeFieldToNull('tableType.ticketLabel.zh-CN')
                    },
              }}
              handleChange={onChangeInput}
            />
            <TempTextInput
              inputSetting={{
                label: { resource: resource, key: 'ticketType' },
                value: savedTableType?.ticketType?.ticketType,
                onClickEndAdornmentIconButton: () => {
                  onClickTicketTypeInput()
                },
                clear: true,
                name: 'ticketType.ticketType',
                multiline: true,
              }}
              handleChange={onChangeInput}
            />
            <div></div>
            <TempTextInput
              inputSetting={{
                variant: cons.STYLE.VARIANT.STANDARD,
                label: { resource: resource, key: 'ticketTypeEnLabel' },
                value: savedTableType?.ticketType?.label?.en,
                name: 'ticketType.label.en',
                disabled: true,
                multiline: true,
              }}
              handleChange={onChangeInput}
            />
            <TempTextInput
              inputSetting={{
                variant: cons.STYLE.VARIANT.STANDARD,
                label: { resource: resource, key: 'ticketTypeTcLabel' },
                value: savedTableType?.ticketType?.label?.['zh-HK'],
                name: 'ticketType.label.zh-HK',
                disabled: true,
                multiline: true,
              }}
              handleChange={onChangeInput}
            />
            <TempTextInput
              inputSetting={{
                variant: cons.STYLE.VARIANT.STANDARD,
                label: { resource: resource, key: 'ticketTypeScLabel' },
                value: savedTableType?.ticketType?.label?.['zh-CN'],
                name: 'ticketType.label.zh-CN',
                disabled: true,
                multiline: true,
              }}
              handleChange={onChangeInput}
            />
            <TempAutoSelectInput
              inputSetting={{
                label: { resource: resource, key: 'groupedSection' },
                value: savedTableType?.groupedSection?.groupedSection,
                selectValue: cons.CHOICES.QUEUE_TEMPLATE.TIME_SECTION_ID,
                variant: cons.STYLE.VARIANT.STANDARD,
                name: 'groupedSection.groupedSection',
                disableStatusThemeColor: true,
                helperTextIcon: true,
                helperText: QueueTemplateValidation.getErrorMessages(validationCo.KEY_GROUPED_SECTION, savedTableType.customId).map((error) => {
                  return error
                }),
              }}
              handleChange={onChangeInput}
            />
            <div></div>
            <TempTextInput
              inputSetting={{
                variant: cons.STYLE.VARIANT.STANDARD,
                label: { resource: resource, key: 'groupedSectionEnLabel' },
                value: savedTableType?.groupedSection?.label?.en,
                name: 'groupedSection.label.en',
                disabled: true,
                multiline: true,
              }}
              handleChange={onChangeInput}
            />
            <TempTextInput
              inputSetting={{
                variant: cons.STYLE.VARIANT.STANDARD,
                label: { resource: resource, key: 'groupedSectionTcLabel' },
                value: savedTableType?.groupedSection?.label?.['zh-HK'],
                name: 'groupedSection.label.zh-HK',
                disabled: true,
                multiline: true,
              }}
              handleChange={onChangeInput}
            />
            <TempTextInput
              inputSetting={{
                variant: cons.STYLE.VARIANT.STANDARD,
                label: { resource: resource, key: 'groupedSectionScLabel' },
                value: savedTableType?.groupedSection?.label?.['zh-CN'],
                name: 'groupedSection.label.zh-CN',
                disabled: true,
                multiline: true,
              }}
              handleChange={onChangeInput}
            />
          </MUIAccordion>
          <MUIAccordion title="QUOTA">
            <div></div>
            <TempTextInput
              inputSetting={{
                label: { resource: resource, key: 'dailyQuota' },
                value: savedTableType.dailyQuota === -1 ? '' : savedTableType.dailyQuota,
                name: 'dailyQuota',
                placeholder: savedTableType.dailyQuota === -1 ? 'Unlimited' : '',
                onClickEndAdornmentIconButton: () => {
                  onClickUnlimitedEndButton('dailyQuota')
                },
                endAdornmentIconButton: <AllInclusiveIcon fontSize={cons.SIZE.SMALL} />,
                helperTextIcon: true,
                helperText: QueueTemplateValidation.getErrorMessages(validationCo.KEY_DAILY_QUOTA, savedTableType.customId).map((error) => {
                  return error
                }),
                type: cons.TYPE.NUMBER,
              }}
              handleChange={onChangeInput}
            />
            <TempTextInput
              inputSetting={{
                label: { resource: resource, key: 'personalQuota' },
                value: savedTableType.personalQuota === -1 ? '' : savedTableType.personalQuota,
                name: 'personalQuota',
                placeholder: savedTableType.personalQuota === -1 ? 'Unlimited' : '',
                onClickEndAdornmentIconButton: () => {
                  onClickUnlimitedEndButton('personalQuota')
                },
                endAdornmentIconButton: <AllInclusiveIcon fontSize={cons.SIZE.SMALL} />,
                helperTextIcon: true,
                helperText: QueueTemplateValidation.getErrorMessages(validationCo.KEY_PERSONAL_QUOTA, savedTableType.customId).map((error) => {
                  return error
                }),
                type: cons.TYPE.NUMBER,
              }}
              handleChange={onChangeInput}
            />
          </MUIAccordion>
          <MUIAccordion title="SIZE">
            {savedTableType.sizeSelectable && (
              <>
                <TempTextInput
                  inputSetting={{
                    label: { resource: resource, key: 'minSize' },
                    value: savedTableType.minSize,
                    name: 'minSize',
                    helperTextIcon: true,
                    helperText: QueueTemplateValidation.getErrorMessages(validationCo.KEY_MIN_SIZE, savedTableType.customId).map((error) => {
                      return error
                    }),
                    type: cons.TYPE.NUMBER,
                  }}
                  handleChange={onChangeInput}
                />
                <TempTextInput
                  inputSetting={{
                    label: { resource: resource, key: 'maxSize' },
                    value: savedTableType.maxSize,
                    name: 'maxSize',
                    helperTextIcon: true,
                    helperText: QueueTemplateValidation.getErrorMessages(validationCo.KEY_MAX_SIZE, savedTableType.customId).map((error) => {
                      return error
                    }),
                    type: cons.TYPE.NUMBER,
                  }}
                  handleChange={onChangeInput}
                />
              </>
            )}

            <TempAutoSelectInput
              inputSetting={{
                label: { resource: resource, key: 'sizeSelectable' },
                value: savedTableType.sizeSelectable,
                selectValue: cons.CHOICES.QUEUE_TEMPLATE.SIZE_SELECTABLE,
                name: 'sizeSelectable',
                helperTextIcon: true,
                helperText: QueueTemplateValidation.getErrorMessages(validationCo.KEY_SIZE_SELECTABLE, savedTableType.customId).map((error) => {
                  return error
                }),
                disableClearable: true,
              }}
              handleChange={onChangeInput}
            />
          </MUIAccordion>
          <MUIAccordion title="COLORS">
            <DefaultColorSetDropDown
              resource={resource}
              resourceKey={'applyTableTypeBackgroundColor'}
              onChangeInput={onChangeInput}
              value={savedTableType.applyTableTypeBackgroundColor}
              savedDefaultTableTypeColorList={savedDefaultTableTypeColorList}
            />
            <TempTextInput
              inputSetting={{
                label: { resource: resource, key: 'tableTypeBackgroundColor' },
                value: savedTableType?.tableType?.kioskColor?.backgroundColor,
                name: 'tableType.kioskColor.backgroundColor',
                freeSolo: true,
                endAdornmentIconButton: (
                  <QueueTemplateColorPicker
                    color={savedTableType?.tableType?.kioskColor?.backgroundColor}
                    setColor={(color) => onChangeInput('tableType.kioskColor.backgroundColor', color)}
                  />
                ),
                onClickEndAdornmentIconButton: () => {},
                helperTextIcon: true,
                helperText: QueueTemplateValidation.getErrorMessages(validationCo.KEY_TABLE_TYPE_BACKGROUND_COLOR, savedTableType.customId).map(
                  (error) => {
                    return error
                  }
                ),
                freeSoloUppercase: true,
                isColorFieldSpecialCase: true,
                clear: true,
              }}
              handleChange={onChangeInput}
            />
            <TempTextInput
              inputSetting={{
                label: { resource: resource, key: 'tableTypeForegroundColor' },
                value: savedTableType?.tableType?.kioskColor?.foregroundColor,
                name: 'tableType.kioskColor.foregroundColor',
                freeSolo: true,
                endAdornmentIconButton: (
                  <QueueTemplateColorPicker
                    color={savedTableType?.tableType?.kioskColor?.foregroundColor}
                    setColor={(color) => onChangeInput('tableType.kioskColor.foregroundColor', color)}
                  />
                ),
                onClickEndAdornmentIconButton: () => {},
                helperTextIcon: true,
                helperText: QueueTemplateValidation.getErrorMessages(validationCo.KEY_TABLE_TYPE_FOREGROUND_COLOR, savedTableType.customId).map(
                  (error) => {
                    return error
                  }
                ),
                freeSoloUppercase: true,
                isColorFieldSpecialCase: true,
                clear: true,
              }}
              handleChange={onChangeInput}
            />
            <DefaultColorSetDropDown
              resource={resource}
              resourceKey={'applyTableTypeMobileBackgroundColor'}
              onChangeInput={onChangeInput}
              value={savedTableType.applyTableTypeMobileBackgroundColor}
              savedDefaultTableTypeColorList={savedDefaultTableTypeColorList}
            />
            <TempTextInput
              inputSetting={{
                label: { resource: resource, key: 'tableTypeMobileBackgroundColor' },
                value: savedTableType?.tableType?.mobileColor?.backgroundColor,
                name: 'tableType.mobileColor.backgroundColor',
                freeSolo: true,
                endAdornmentIconButton: (
                  <QueueTemplateColorPicker
                    color={savedTableType?.tableType?.mobileColor?.backgroundColor}
                    setColor={(color) => onChangeInput('tableType.mobileColor.backgroundColor', color)}
                  />
                ),
                onClickEndAdornmentIconButton: () => {},
                helperTextIcon: true,
                helperText: QueueTemplateValidation.getErrorMessages(
                  validationCo.KEY_TABLE_TYPE_MOBILE_BACKGROUND_COLOR,
                  savedTableType.customId
                ).map((error) => {
                  return error
                }),
                freeSoloUppercase: true,
                isColorFieldSpecialCase: true,
                clear: true,
              }}
              handleChange={onChangeInput}
            />
            <TempTextInput
              inputSetting={{
                label: { resource: resource, key: 'tableTypeMobileForegroundColor' },
                value: savedTableType?.tableType?.mobileColor?.foregroundColor,
                name: 'tableType.mobileColor.foregroundColor',
                endAdornmentIconButton: (
                  <QueueTemplateColorPicker
                    color={savedTableType?.tableType?.mobileColor?.foregroundColor}
                    setColor={(color) => onChangeInput('tableType.mobileColor.foregroundColor', color)}
                  />
                ),
                onClickEndAdornmentIconButton: () => {},
                helperTextIcon: true,
                helperText: QueueTemplateValidation.getErrorMessages(
                  validationCo.KEY_TABLE_TYPE_MOBILE_FOREGROUND_COLOR,
                  savedTableType.customId
                ).map((error) => {
                  return error
                }),
                freeSoloUppercase: true,
                isColorFieldSpecialCase: true,
                clear: true,
              }}
              handleChange={onChangeInput}
            />
          </MUIAccordion>
          <MUIAccordion title="OTHER CONFIGS">
            <TempAutoSelectInput
              inputSetting={{
                label: { resource: resource, key: 'queueType' },
                value: savedTableType.queueType,
                selectValue: cons.CHOICES.QUEUE_TEMPLATE.QUEUE_TYPE,
                name: 'queueType',
              }}
              handleChange={onChangeInput}
            />
            <TempAutoSelectInput
              inputSetting={{
                label: { resource: resource, key: 'displayType' },
                value: savedTableType.displayType,
                selectValue: cons.CHOICES.QUEUE_TEMPLATE.DISPLAY_TYPE,
                name: 'displayType',
              }}
              handleChange={onChangeInput}
            />
            <TempAutoSelectInput
              inputSetting={{
                label: { resource: resource, key: 'rollTagType' },
                value: savedTableType.rollTagType,
                selectValue: cons.CHOICES.QUEUE_TEMPLATE.ROLL_TAG_TYPE,
                name: 'rollTagType',
              }}
              handleChange={onChangeInput}
            />
            <TempTextInput
              inputSetting={{
                label: { resource: resource, key: 'nextRemind' },
                value: savedTableType.nextRemind,
                name: 'nextRemind',
                helperTextIcon: true,
                helperText: QueueTemplateValidation.getErrorMessages(validationCo.KEY_NEXT_REMIND, savedTableType.customId).map((error) => {
                  return error
                }),
              }}
              handleChange={onChangeInput}
            />
            <SoundInfoVoiceDropdown
              value={savedTableType.voiceCode}
              resource={resource}
              onChangeInput={onChangeInput}
              soundVoiceList={soundVoiceList}
            />
                      <TempAutoSelectInput
              inputSetting={{
                label: { resource: resource, key: 'autoCheckOut' },
                value: savedTableType.autoCheckOut,
                selectValue: BOOLEAN_OPTIONS,
                name: 'autoCheckOut',
                disableClearable: true
              }}
              handleChange={onChangeInput}
            />
            <TempTextInput
              inputSetting={{
                label: { resource: resource, key: 'vipMultiplier' },
                value: savedTableType.vipMultiplier,
                name: 'vipMultiplier',
                clear: true,
                type: cons.TYPE.NUMBER,
                // helperTextIcon: true,
                // helperText: QueueTemplateValidation.getErrorMessages(validationCo.KEY_NEXT_REMIND, savedTableType.customId).map((error) => {
                //   return error
                // }),
              }}
              handleChange={onChangeInput}
            />
          </MUIAccordion>
          <MUIAccordion title="AUTO TASK">
            <Stack direction="row" justifyContent="flex-end" sx={{ mb: 2 }}>
              <TempBtn
                btnSetting={{
                  variant: cons.STYLE.VARIANT.CONTAINED,
                  color: cons.STYLE.PRIMARY,
                  label: { key: 'add' },
                  icon: <AddIcon />,
                  onClick: onAddAutoTaskItem,
                }}
              />
            </Stack>

            {autoTaskList.length === 0 ? (
              <Typography variant="body2" color="text.secondary">
                No auto task items yet.
              </Typography>
            ) : (
              <Stack spacing={2}>
                {autoTaskList.map((autoTask, index) => (
                  <Box
                    key={autoTask.id || `auto-task-${index}`}
                    sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2, p: 2 }}
                  >
                    <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
                      <Typography variant="subtitle2">{autoTask.id || `Auto task ${index + 1}`}</Typography>
                      <Tooltip title="Remove">
                        <IconButton color="error" onClick={() => onRemoveAutoTaskItem(index)}>
                          <DeleteIcon />
                        </IconButton>
                      </Tooltip>
                    </Stack>

                        <TempAutoSelectInput
                          inputSetting={{
                            label: { resource: resource, key: 'taskType' },
                            value: autoTask.taskType,
                            selectValue: TASK_TYPE_OPTIONS,
                            name: `autoTaskList.${index}.taskType`,
                            disableClearable: false,
                          }}
                          handleChange={onChangeInput}
                        />

                        <TempAutoSelectInput
                          inputSetting={{
                            name: `autoTaskList.${index}.mobile`,
                            label: { resource: resource, key: 'mobile' },
                            value: autoTask.mobile,
                            selectValue: BOOLEAN_OPTIONS,
                          }}
                          handleChange={onChangeInput}
                          index={index}
                        />

                        <TempAutoSelectInput
                          inputSetting={{
                            name: `autoTaskList.${index}.kiosk`,
                            label: { resource: resource, key: 'kiosk' },
                            value: autoTask.kiosk,
                            selectValue: BOOLEAN_OPTIONS,
                          }}
                          handleChange={onChangeInput}
                          index={index}
                        />

                        <TempAutoSelectInput
                          inputSetting={{
                            label: { resource: resource, key: 'executionType' },
                            value: autoTask.executionType,
                            selectValue: EXECUTION_TYPE_OPTIONS,
                            name: `autoTaskList.${index}.executionType`,
                            disableClearable: false,
                          }}
                          handleChange={onChangeInput}
                        />

                        {
                          autoTask.executionType === 'EXACT_DATE_TIME' && (
                            <TempTextInput
                              inputSetting={{
                                label: { resource: resource, key: 'executionExactDateTime' },
                                value: autoTask.executionExactDateTime,
                                name: `autoTaskList.${index}.executionExactDateTime`,
                                type: cons.TYPE.DATETIME_LOCAL,
                                clear: true,
                              }}
                              handleChange={onChangeInput}
                            />
                          )
                        }

                        {
                          autoTask.executionType === 'RESET_TIME' && (
                            <TempTextInput
                              inputSetting={{
                                label: { resource: resource, key: 'executionResetTime' },
                                value: autoTask.executionResetTime,
                                name: `autoTaskList.${index}.executionResetTime`,
                                type: cons.TYPE.TIME,
                                clear: true,
                                step: 1,
                              }}
                              handleChange={onChangeInput}
                            />
                          )
                        }

                        {
                          autoTask.executionType === 'RESET_OFFSET_MINUTE' && (
                            <TempTextInput
                              inputSetting={{
                                label: { resource: resource, key: 'executionOffsetMinute' },
                                value: autoTask.executionOffsetMinute,
                                name: `autoTaskList.${index}.executionOffsetMinute`,
                                type: cons.TYPE.NUMBER,
                                clear: true,
                              }}
                              handleChange={onChangeInput}
                            />
                          )
                        }

                        <TempAutoSelectInput
                          inputSetting={{
                            label: { resource: resource, key: 'status' },
                            value: autoTask.status,
                            selectValue: cons.CHOICES.QUEUE_TEMPLATE.STATUS,
                            name: `autoTaskList.${index}.status`,
                            disableClearable: true,
                          }}
                          handleChange={onChangeInput}
                        />
                  </Box>
                ))}
              </Stack>
            )}
            {QueueTemplateValidation.getErrorMessages(validationCo.KEY_AUTO_TASK_LIST, savedTableType.customId).length > 0 && (
              <span className='error-message'>
                <CancelIcon className='error-message-icon' fontSize={cons.SIZE.SMALL} />
                <Typography variant="body2" color="error">
                  {QueueTemplateValidation.getErrorMessages(validationCo.KEY_AUTO_TASK_LIST, savedTableType.customId).map((error) => {
                    return error
                  })}
                </Typography>
              </span>
            )}
          </MUIAccordion>
          <MUIAccordion title="ICON ASSET">
            <div className="image">
              <UploadImageV2
                // type={IMAGE_TYPE.RESTAURANT_IMAGE}
                title={{ resource: resource, key: 'tableTypeMobileIcon' }}
                name="tableType.mobileIcon"
                saveImage={handleSaveImage}
                picture={savedTableType?.tableType?.mobileIcon}
                uploadType={UPLOAD_TYPE.FORMDATA}
                uploadImagePath={cons.PATH.SHOP.UPLOAD_RESTAURANT_MEDIA}
                size={PICTURE_SIZE.MID}
                allowedFileExtensionList={['image/jpeg', 'image/jpg']}
                removeImage={() => onChangeInput('tableType.mobileIcon', null)}
                showApplyToAll={true}
              />
            </div>
            <div className="image">
              <UploadImageV2
                // type={IMAGE_TYPE.RESTAURANT_IMAGE}
                title={{ resource: resource, key: 'tableTypeKioskIcon' }}
                name="tableType.kioskIcon"
                saveImage={handleSaveImage}
                picture={savedTableType?.tableType?.kioskIcon}
                uploadType={UPLOAD_TYPE.FORMDATA}
                uploadImagePath={cons.PATH.SHOP.UPLOAD_RESTAURANT_MEDIA}
                size={PICTURE_SIZE.MID}
                allowedFileExtensionList={['image/jpeg', 'image/jpg']}
                removeImage={() => onChangeInput('tableType.kioskIcon', null)}
                showApplyToAll={true}
              />
            </div>
          </MUIAccordion>
        </>
      ),
      btn: false,
    },
  ]

  function onSelectCheckbox(e, name) {
    const newSavedQueueTemplate = _.cloneDeep(savedQueueTemplate)
    const newSavedTableType = _.cloneDeep(savedTableType)

    let onUseTimeSectionIdx = newSavedQueueTemplate.findIndex((timeSection) => timeSection.customId === newSavedTableType.timeSectionCustomId)
    let onUseTimeSection = newSavedQueueTemplate.find((timeSection) => timeSection.customId === newSavedTableType.timeSectionCustomId)

    switch (name.key) {
      case 'isAutoTranslateTableTypeScLabel':
        newSavedTableType.disableTableTypeKioskLabel = e

        if (e) {
          newSavedTableType.tableType.kioskLabel['zh-CN'] = newSavedTableType?.tableType?.kioskLabel?.['zh-HK']
            ? sify(newSavedTableType?.tableType?.kioskLabel?.['zh-HK'])
            : newSavedTableType?.tableType?.kioskLabel?.['zh-HK']
        }
        break
      case 'isAutoTranslateTableTypeMobileScLabel':
        newSavedTableType.disableTableTypeMobileLabel = e
        if (e) {
          newSavedTableType.tableType.mobileLabel['zh-CN'] = newSavedTableType?.tableType?.mobileLabel?.['zh-HK']
            ? sify(newSavedTableType?.tableType?.mobileLabel?.['zh-HK'])
            : newSavedTableType?.tableType?.mobileLabel?.['zh-HK']
        }
        break
      case 'isAutoTranslateTableTypeTicketScLabel':
        newSavedTableType.disableTableTypeTicketLabel = e
        if (e) {
          newSavedTableType.tableType.ticketLabel['zh-CN'] = newSavedTableType?.tableType?.ticketLabel?.['zh-HK']
            ? sify(newSavedTableType?.tableType?.ticketLabel?.['zh-HK'])
            : newSavedTableType?.tableType?.ticketLabel?.['zh-HK']
        }
        break
      case 'isAutoTranslateGroupedSectionLabel':
        newSavedTableType.disableGroupedSection = e
        if (e) {
          newSavedTableType.groupedSection.label['zh-CN'] = newSavedTableType?.groupedSection?.label?.['zh-HK']
            ? sify(newSavedTableType?.groupedSection?.label?.['zh-HK'])
            : newSavedTableType?.groupedSection?.label?.['zh-HK']
        }
        break
      case 'isAutoTranslateGroupedSectionDescription':
        newSavedTableType.disableGroupedSectionDescription = e
        if (e) {
          newSavedTableType.groupedSection.description['zh-CN'] = newSavedTableType?.groupedSection?.description?.['zh-HK']
            ? sify(newSavedTableType?.groupedSection?.description?.['zh-HK'])
            : newSavedTableType?.groupedSection?.description?.['zh-HK']
        }
        break
      default:
    }

    let onUseTableTypeIndex = onUseTimeSection.tableTypeList.findIndex((item) => item.customId === newSavedTableType.customId)
    let onUseTableType = onUseTimeSection.tableTypeList.find((item) => item.customId === newSavedTableType.customId)

    onUseTableType = newSavedTableType
    if (onUseTableTypeIndex >= 0) {
      newSavedQueueTemplate[onUseTimeSectionIdx].tableTypeList[onUseTableTypeIndex] = onUseTableType
      dispatch(setQueueTemplateTableTypeValue(onUseTableType))
    } else {
      onUseTableType.customId = 'table_' + customIdNumber
      setCustomIdNumber(customIdNumber + 1)
      newSavedQueueTemplate[onUseTimeSectionIdx]?.tableTypeList.push(onUseTableType)
      dispatch(setQueueTemplateTableTypeValue(onUseTableType))
    }

    dispatch(setQueueTemplate(newSavedQueueTemplate))
    const newQueueTemplateInput = _.cloneDeep(cons.TIME_SECTION_DEFAULT_VALUE)
    dispatch(setQueueTemplateTimeSectionValue(newQueueTemplateInput))

    QueueTemplateValidation.validateTemplateTableType(newSavedQueueTemplate)
    setErrorVersion(QueueTemplateValidation.getVersion())
  }

  const onClickUnlimitedEndButton = (name) => {
    onChangeInput(name, -1)
  }

  const onChangeFieldToNull = (name) => {
    onChangeInput(name, null)
  }

  const onClickTicketTypeInput = () => {    
    setShowTicketTypeTextPanel(true)
  }

  const onCloseTicketTypeDrawer = () => {
    setShowTicketTypeTextPanel(false)
  }

  const onRowClick = (data) => {
    onChangeInput('ticketType', data)
    setShowTicketTypeTextPanel(false)
  }

  const onCloseCreateTicketTypeDrawer = () => {
    setShowTicketTypeCreatePanel(false)
    setReload(true)
  }

  const generateTimeSectionDescription = () => {
    let label = ''

    label += savedTableType.startTime.substring(0, 5) + ' - '

    if (savedTableType.endTime && savedTableType.endTime.substring(3, 5) === '59' && savedTableType.endTime.substring(6, 8) === '59') {
      label += Number(savedTableType.endTime.substring(0, 2)) + 1 + ':00'
    } else if (savedTableType.endTime && savedTableType.endTime.substring(6, 8) === '59') {
      let endTime = Number(savedTableType.endTime.substring(3, 5)) + 1

      if (endTime < 10) {
        endTime = '0' + endTime
      }

      label += savedTableType.endTime.substring(0, 2) + ':' + endTime
    } else {
      label += savedTableType.endTime.substring(0, 5)
    }

    onChangeInput('timeSectionDescription', label)
  }

  function handleSaveImage(name, image, index, applyToAll) {
      const newSavedQueueTemplate = _.cloneDeep(savedQueueTemplate)
      const newSavedTableType = _.cloneDeep(savedTableType)

      let onUseTimeSectionIdx = newSavedQueueTemplate.findIndex((timeSection) => timeSection.customId === newSavedTableType.timeSectionCustomId)
      let onUseTimeSection = newSavedQueueTemplate.find((timeSection) => timeSection.customId === newSavedTableType.timeSectionCustomId)
      let onUseTableTypeIdx = onUseTimeSection?.tableTypeList.findIndex((tableType) => tableType.customId === newSavedTableType.customId)
      let onUseTableType = onUseTimeSection?.tableTypeList.find((tableType) => tableType.customId === newSavedTableType.customId)

      if(applyToAll){
        newSavedTableType.tableType.mobileIcon = image
        newSavedTableType.tableType.kioskIcon = image
      } else {
        if (name.includes('.')) {
          _.set(newSavedTableType, name, image)
        } else {
          newSavedTableType[`${name}`] = image;
        }
      }

      if (onUseTableTypeIdx >= 0) {
        newSavedQueueTemplate[onUseTimeSectionIdx].tableTypeList[onUseTableTypeIdx] = newSavedTableType
        dispatch(setQueueTemplateTableTypeValue(newSavedTableType))
      } else {
        onUseTableType.customId = 'table_' + customIdNumber
        setCustomIdNumber(customIdNumber + 1)
        newSavedQueueTemplate[onUseTimeSectionIdx]?.tableTypeList.push(newSavedTableType)
        dispatch(setQueueTemplateTableTypeValue(newSavedTableType))
      }

      dispatch(setQueueTemplate(newSavedQueueTemplate))
      const newQueueTemplateInput = _.cloneDeep(cons.TIME_SECTION_DEFAULT_VALUE)
      dispatch(setQueueTemplateTimeSectionValue(newQueueTemplateInput))
    }

  function onChangeInput(name, e) {
    // Simplified handler: support nested paths (dot notation) and grouped labels
    const newSavedQueueTemplate = _.cloneDeep(savedQueueTemplate)
    const newSavedTableType = _.cloneDeep(savedTableType)

    const timeSectionIdx = newSavedQueueTemplate.findIndex((ts) => ts.customId === newSavedTableType.timeSectionCustomId)
    const timeSection = newSavedQueueTemplate.find((ts) => ts.customId === newSavedTableType.timeSectionCustomId)
    const tableTypeIdx = timeSection?.tableTypeList.findIndex((tt) => tt.customId === newSavedTableType.customId)

    // numeric fields
    const intFields = ['minSize', 'maxSize', 'nextRemind']
    const quotaFields = ['dailyQuota', 'personalQuota']
    const nullableFields = ['sessionDate']

    // helper to set nested path or plain key
    const setField = (path, val) => {
      if (path.includes('.')) {
        _.set(newSavedTableType, path, val)
      } else {
        newSavedTableType[path] = val
      }
    }

    // auto-translate helper: when editing a Traditional Chinese field and auto-translate flag is set,
    // also update the Simplified Chinese sibling (.zh-CN) using sify()
    const maybeAutoTranslate = (path, val) => {
      const tcLocaleMatch = path.match(/\.(zh-HK|zh-TW)$/)
      if (!tcLocaleMatch) return
      const scPath = path.replace(/\.(zh-HK|zh-TW)$/, '.zh-CN')

      // determine which auto-translate flag applies
      const parent = path.split('.').slice(0, -1).join('.') // e.g. tableType.kioskLabel

      const flagMap = [
        { test: (p) => p.includes('tableType.kioskLabel'), flag: 'disableTableTypeKioskLabel' },
        { test: (p) => p.includes('tableType.mobileLabel'), flag: 'disableTableTypeMobileLabel' },
        { test: (p) => p.includes('tableType.ticketLabel'), flag: 'disableTableTypeTicketLabel' },
        { test: (p) => p.includes('mobile') || p.includes('tableTypeMobile'), flag: 'disableMobileLabel' },
        { test: (p) => p.includes('ticket') || p.includes('ticketType'), flag: 'disableTicketLabel' },
        { test: (p) => p.includes('groupedSection') && p.includes('description'), flag: 'disableGroupedSectionDescription' },
      ]

      const matched = flagMap.find((m) => m.test(parent))
      if (matched && newSavedTableType[matched.flag] === true) {
        _.set(newSavedTableType, scPath, val ? sify(val) : null)
      }
    }

    // Special handling for a few cases
    if (intFields.includes(name)) {
      setField(name, e && Number.isInteger(Number(e)) ? Number(e) : 0)
    } else if (quotaFields.includes(name)) {
      setField(name, e && Number.isInteger(Number(e)) ? Number(e) : -1)
    } else if (nullableFields.includes(name)) {
      setField(name, e || null)
    } else if (name === 'cutOffTime') {
      setField(name, e)
    } else if (name === 'ticketType') {
      // accept object from dropdown
      setField('ticketType.ticketType', e.ticketType)
      setField('ticketType.label.zh-HK', e.tcName)
      setField('ticketType.label.en', e.enName)
      setField('ticketType.label.zh-CN', e.scName)
    } else if (name === 'applyTableTypeBackgroundColor' || name === 'applyTableTypeMobileBackgroundColor') {
      if (e) {
        const [foregroundColor, backgroundColor] = e.split('&')
        if (name === 'applyTableTypeBackgroundColor') {
          newSavedTableType.tableType.kioskColor.backgroundColor = backgroundColor
          newSavedTableType.displayTableTypeBackgroundColor = backgroundColor
          newSavedTableType.tableType.kioskColor.foregroundColor = foregroundColor
          newSavedTableType.displayTableTypeForegroundColor = foregroundColor
        } else {
          newSavedTableType.tableType.mobileColor.backgroundColor = backgroundColor
          newSavedTableType.tableType.mobileColor.foregroundColor = foregroundColor
        }
      } else {
        if (name === 'applyTableTypeBackgroundColor') {
          newSavedTableType.tableType.kioskColor.backgroundColor = null
          newSavedTableType.displayTableTypeBackgroundColor = getTableTypeBackgroundColor(
            e,
            tableTypeIdx,
            savedTableTypeColorList || savedDefaultTableTypeColorList
          )
          newSavedTableType.tableType.kioskColor.foregroundColor = null
          newSavedTableType.displayTableTypeForegroundColor = getTableTypeForegroundColor(
            e,
            tableTypeIdx,
            savedTableTypeColorList || savedDefaultTableTypeColorList
          )
        } else {
          newSavedTableType.tableType.mobileColor.backgroundColor = null
          newSavedTableType.tableType.mobileColor.foregroundColor = null
        }
      }
    } else if (name === 'groupedSection') {
      if (!e) {
        setField(name, null)
        setField('groupedSection.label.zh-HK', null)
        setField('groupedSection.label.en', null)
        setField('groupedSection.label.zh-CN', null)
        setField('groupedSection.description.zh-HK', null)
        setField('groupedSection.description.en', null)
        setField('groupedSection.description.zh-CN', null)
      } else {
        const newGroupedSection = e
        setField(name, e)
        const originalIdx = timeSection?.tableTypeList.findIndex(
          (tableType) => (tableType.customId || tableType.id) === (newSavedTableType.customId || newSavedTableType.id)
        )
        let newTableTypeList = [...timeSection.tableTypeList.slice(0, originalIdx), ...timeSection.tableTypeList.slice(originalIdx + 1)]
        const newTableTypeIdx = timeSection?.tableTypeList.findLastIndex((tableType) => tableType.groupedSection === newGroupedSection)
        newTableTypeList.splice(newTableTypeIdx === -1 ? originalIdx : newTableTypeIdx + 1, 0, newSavedTableType)
        timeSection.tableTypeList = newTableTypeList
      }
    } else if (name === 'sizeSelectable') {
      setField(name, e)
      if (!e) {
        setField('minSize', 1)
        setField('maxSize', 1)
      }
    } else if (name.startsWith('autoTaskList.')) {
      if (name.endsWith('executionExactDateTime')) {
        setField(name, e ? moment(e).valueOf() : null)
      } else if (name.endsWith('executionOffsetMinute')) {
        setField(name, e === '' || e === null || e === undefined ? null : Number(e))
      } else if (name.endsWith('executionType')) {
        setField(name, e)

        // Reset other execution fields when executionType changes
        const regex = /^autoTaskList\.(\d+)\.executionType$/;
        const match = name.match(regex);
        const index = match ? match[1] : null;

        const resetsMap = {
          EXACT_DATE_TIME: ['executionResetTime', 'executionOffsetMinute'],
          RESET_TIME: ['executionExactDateTime', 'executionOffsetMinute'],
          RESET_OFFSET_MINUTE: ['executionExactDateTime', 'executionResetTime'],
        };

        const resets = resetsMap[e] || [];
        resets.forEach((resetField) => {
          const resetPath = `autoTaskList.${index}.${resetField}`;
          setField(resetPath, null);
        });
      } else {
        setField(name, e === '' ? null : e)
      }
    } else {
      // default: accept nested paths (dot notation) or direct keys
      setField(name, e === '' ? null : e)
    }

    // If the edited field was a TC label under zh-HK/zh-TW, maybe auto translate
    maybeAutoTranslate(name, e)

    // assign back into time section list
    const onUseTableType = newSavedTableType
    if (tableTypeIdx >= 0) {
      newSavedQueueTemplate[timeSectionIdx].tableTypeList[tableTypeIdx] = onUseTableType
      dispatch(setQueueTemplateTableTypeValue(onUseTableType))
    } else {
      onUseTableType.customId = 'table_' + customIdNumber
      setCustomIdNumber(customIdNumber + 1)
      newSavedQueueTemplate[timeSectionIdx]?.tableTypeList.push(onUseTableType)
      dispatch(setQueueTemplateTableTypeValue(onUseTableType))
    }

    dispatch(setQueueTemplate(newSavedQueueTemplate))
    const newQueueTemplateInput = _.cloneDeep(cons.TIME_SECTION_DEFAULT_VALUE)
    dispatch(setQueueTemplateTimeSectionValue(newQueueTemplateInput))

    QueueTemplateValidation.validateTemplateTableType(newSavedQueueTemplate)
    setErrorVersion(QueueTemplateValidation.getVersion())
  }

  function onAddAutoTaskItem() {
    const newAutoTaskList = [...autoTaskList, _.cloneDeep(AUTO_TASK_DEFAULT_ITEM)]
    onChangeInput('autoTaskList', newAutoTaskList)
  }

  function onRemoveAutoTaskItem(index) {
    const newAutoTaskList = autoTaskList.filter((_, currentIndex) => currentIndex !== index)
    onChangeInput('autoTaskList', newAutoTaskList)
  }

  function onChangeAutoTaskCheckbox(name, value) {
    onChangeInput(name, !value)
  }

  function getCurrentTimeSectionPossibleParentTableType() {
    const newSavedQueueTemplate = _.cloneDeep(savedQueueTemplate)
    const newSavedTableType = _.cloneDeep(savedTableType)

    let onUseTimeSection = newSavedQueueTemplate.find((item) => item.customId === newSavedTableType.timeSectionCustomId)

    return (
      onUseTimeSection?.tableTypeList
        ?.filter((tableType) => tableType.tableType?.tableType !== savedTableType.tableType?.tableType)
        ?.map((tableType) => ({ name: tableType.tableType?.tableType, value: tableType.tableType?.tableType })) || []
    )
  }

  // useEffect(() => {
  //   console.log('savedTableType', savedTableType)
  // }, [savedTableType])

  return (
    <>
      <EditCreateDisplay
        code={savedTableType && savedTableType.customId ? savedTableType.customId : ''}
        resource={resource}
        tabs={false}
        content={contents}
        saveDialog={{
          open: false,
          dialogActions: [],
        }}
        display={savedTableType.customId ? 'edit' : 'create'}
      />
      <Drawer classes={{ paper: 'drawer-margin-left' }} anchor="right" open={showTicketTypeTextPanel} onClose={onCloseTicketTypeDrawer}>
        <TicketTypeList
          editBtn={false}
          createBtn="custom"
          reload={reload}
          setReload={setReload}
          customCreate={() => {
            setShowTicketTypeCreatePanel(true)
          }}
          onClickListRow={(item) => onRowClick(item)}
          dialogFooterBtn={
            <TempBtn
              btnSetting={{
                variant: cons.STYLE.VARIANT.CONTAINED,
                color: cons.STYLE.PRIMARY,
                onClick: () => onCloseTicketTypeDrawer(),
                icon: <ClearIcon />,
                label: { key: 'close' },
              }}
            />
          }
        />
      </Drawer>
      <Drawer
        classes={{ paper: 'drawer-margin-left' }}
        anchor="right"
        open={showTicketTypeCreatePanel}
        onClose={() => onCloseCreateTicketTypeDrawer()}
      >
        <TicketTypeCreate
          newDialogBtn={[
            {
              label: { key: 'backList' },
              onClick: () => onCloseCreateTicketTypeDrawer(),
              icon: <LowPriorityIcon />,
            },
          ]}
        />
      </Drawer>
    </>
  )
}
